import { Box, Paper } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { NavigationTabs } from "components/NavigationTabs";
import { Tab as ObjectTab } from "components/ObjectPageTabs";
import CompanyDetailsTab from "components/personnelAndFleet/companyDetails/CompanyDetailsTab";
import FleetTab from "components/personnelAndFleet/fleet/FleetTab";
import PersonnelTab from "components/personnelAndFleet/personnel/PersonnelTab";
import { useSetBreadcrumbs } from "code/setBreadcrumbsHelper";
import { LISTING_PAGE_LEVEL } from "constants/BreadcrumbLevel";
import { useSearchParams } from "react-router-dom";

export default function PersonnelAndFleetPage() {
	const [searchParams] = useSearchParams();
	const currentTab = searchParams.get("tab") || "Personnel";
	useSetBreadcrumbs(currentTab, LISTING_PAGE_LEVEL);

	const tabs: ObjectTab[] = [
		{ label: "Personnel", TabComponent: <PersonnelTab /> },
		{
			label: "Fleet",
			TabComponent: <FleetTab />
		},
		{
			label: "Company Details",
			TabComponent: <CompanyDetailsTab />
		}
	];

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<Box
				sx={{
					height: "100%",
					py: { xs: 0, sm: 2, md: 3.5 },
					display: "flex",
					flexDirection: "column",
					overflow: "hidden",
					width: "100%"
				}}
			>
				<Paper
					elevation={0}
					sx={{
						borderRadius: 1,
						border: 1,
						borderColor: "border.primary",
						display: "flex",
						flexDirection: "column",
						flexGrow: 1,
						overflow: "hidden",
						boxSizing: "border-box"
					}}
				>
					<NavigationTabs
						tabs={tabs}
						defaultTab="Personnel"
						tabScopedParams={["status", "search"]}
					/>
				</Paper>
			</Box>
		</LocalizationProvider>
	);
}
